import { SafeAreaView as RNSafeAreaView, Edges } from "react-native-safe-area-context"
import { ReactNode } from "react"
import { ViewStyle } from "react-native"

type SafeAreaViewProps = {
  children: ReactNode
  style?: ViewStyle
  edges?: Edges
  testID?: string
}

export function SafeAreaView({
  children,
  style = {},
  edges = ["top", "bottom", "left", "right"],
  testID,
}: SafeAreaViewProps) {
  return (
    <RNSafeAreaView style={style} edges={edges} testID={testID}>
      {children}
    </RNSafeAreaView>
  )
}
